// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1744) return "css/1744.234294ece9e2fefe94a2.css";
	if (chunkId === 9335) return "css/9335.ec0402e77edc9924d918.css";
	// return url for filenames based on template
	return undefined;
};